module.exports = __webpack_public_path__ + "img/ana.90503611.svg";